export const GRAPHQL_URL =
  import.meta.env.VITE_GRAPHQL_URL || 'http://localhost:4000/graphql';

export const BASE_URL = (
  import.meta.env.VITE_BASE_URL || 'http://localhost:4000'
).replace(/\/$/, '');

export const MEDIA_URL = (
  import.meta.env.VITE_MEDIA_URL ||
  import.meta.env.VITE_BASE_URL ||
  'http://localhost:8090'
).replace(/\/$/, '');

// The web app's public origin is SITE_URL in src/seo/urls.ts — canonicals,
// og:url, JSON-LD and share links all use it, never window.location.origin.

/** Google Play listing for the Android app. */
export const ANDROID_APP_URL =
  'https://play.google.com/store/apps/details?id=com.promostork.promostork';

/**
 * App Store listing for the iOS app. Empty until an iOS build is published —
 * nothing in the UI offers iOS while it is, and setting it is all the footer
 * needs to show the App Store badge.
 */
export const IOS_APP_URL = '';

/** localStorage key for the dismissal of the Android "get the app" banner. */
export const APP_BANNER_DISMISSED_KEY = 'androidAppBannerDismissed';

/** localStorage key for the persisted auth session — same shape as mobile: { user, token }. */
export const AUTH_STORAGE_KEY = '@AuthData';

/** localStorage key for the theme preference: 'light' | 'dark' | 'system'. */
export const THEME_STORAGE_KEY = 'theme';

/**
 * WEB OAuth client id for Sign in with Google. NOT the Gmail-sending client the
 * backend uses for transactional mail — that one is a different credential in
 * the same Google Cloud project and must never be reused here.
 *
 * Public by design: Vite inlines it into the bundle at build time and Google
 * Identity Services expects it in the page. There is no client secret in this
 * flow — the backend verifies Google's signature against Google's public keys.
 *
 * Empty when unset, so local dev without the var renders no button rather than
 * a broken one (see GoogleSignInButton).
 */
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '';
